import { useAuth0 } from "@auth0/auth0-vue";
import * as Sentry from "@sentry/vue";
import axios from "axios";
import { inject } from "vue";

import { useErrorsStore } from "@/stores/errors";

export default function useAxios() {

    const config = inject('config')
    const { getAccessTokenSilently } = useAuth0();
    const { pushError, pushErrorCode } = useErrorsStore();

    const instance = axios.create({
        baseURL: config.AOL_API_URL,
        timeout: 240000
    });

    instance.interceptors.request.use(async (config) => {
        config.headers['Authorization'] = 'Bearer ' + await getAccessTokenSilently();
        return config;
    })

    instance.interceptors.response.use((response) => {
        return response;
    }, (error) => {
        if (error.code === 'ERR_NETWORK' || error.code === 'ECONNABORTED' || !error.response) {
            pushError({
                message: 'Connection error',
                severity: 'fatal'
            });
            Sentry.captureException(error, {
                extra: {
                    code: 'ERR_NETWORK'
                }
            });
            return Promise.reject(error);
        }
        const status = error.response?.status;
        const statusCategory = Math.floor(status / 100);
        if (statusCategory === 5 || statusCategory === 4) {
            const code = error.response?.data?.code;
            let severity;
            if (
                code === null || code === 'unknown-cause' || code === 'timeout-error'
            ) {
                severity = 'fatal'; //force refresh
            } else if (code === 'access-denied') {
                severity = 'critical'; //force refresh and logout
            } else {
                severity = 'warning'; //standard disposable modal
            }
            pushErrorCode(code, severity);
            if(code !== 'other-offer-received') {
                Sentry.captureException(error, {
                    extra: {
                        response: error.response.data
                    }
                });
            }
        }
        return Promise.reject(error);
    });

    return instance
}

